<input type="text" ngDefaultControl nbInput [placeholder]="placeholder" fullWidth />
